import { Col, Row } from 'antd';
import React from 'react';
import ReportRow from '../../Search/components/ReportRow';
import WEB from '../../../assets/pdf/WEB.pdf';
import XLS from '../../../assets/pdf/XLS.pdf';
import XML from '../../../assets/pdf/XML.pdf';
import WEB_EN from '../../../assets/pdf/WEB_EN.pdf';
import XLS_EN from '../../../assets/pdf/XLS_EN.pdf';
import XML_EN from '../../../assets/pdf/XML_EN.pdf';
import { useTranslation } from 'react-i18next';
import CompanyDataCard from '../../../components/reusable/CompanyDataCard';
import i18n from 'i18next';

const Instructions = () => {
  const { t } = useTranslation();

  return (
    <>
      <CompanyDataCard>
        <Row gutter={[32, 16]} className="container">
          <Col xs={24} md={24} lg={19} xl={16}>
            <ReportRow
              reportName={t('administration.selectProduct.documents.web')}
              onBtnClick={() => {
                window.open(`${i18n.language === 'lt-LT' ? WEB : WEB_EN}`, '_blank');
              }}
            />
            <ReportRow
              reportName={t('administration.selectProduct.documents.xls')}
              onBtnClick={() => {
                window.open(`${i18n.language === 'lt-LT' ? XLS : XLS_EN}`, '_blank');
              }}
            />
            <ReportRow
              reportName={t('administration.selectProduct.documents.xml')}
              onBtnClick={() => {
                window.open(`${i18n.language === 'lt-LT' ? XML : XML_EN}`, '_blank');
              }}
            />
          </Col>
        </Row>
      </CompanyDataCard>
    </>
  );
};

export default Instructions;
